import { render, staticRenderFns } from "./PushMessageItem.vue?vue&type=template&id=6043ca2e&"
import script from "./PushMessageItem.vue?vue&type=script&lang=js&"
export * from "./PushMessageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports